// extracted by mini-css-extract-plugin
module.exports = {"countdown":"Lv-z","srOnly":"Mv-z"};